import {Base} from "@/api/Base"

export class GiGetByIdUplRec extends Base {
    path = "gi/getByIdUplRec"
}